module.exports = __webpack_public_path__ + "img/dubbelzijdig_25x12mm.9fd26830.jpg";